import { useEffect } from 'react';
import { Image, ValImage } from '@valbuild/next';
import { Arrow } from '../SVGs';

interface ImageModalProps {
  showImageCaptions: boolean;
  image: Image | null;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
}

const ImageModal = ({
  showImageCaptions,
  image,
  onClose,
  onNext,
  onPrev,
}: ImageModalProps) => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    const handleRightArrowKey = (event: KeyboardEvent) => {
      if (event.key === 'ArrowRight') {
        onNext();
      }
    };

    const handleLeftArrowKey = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft') {
        onPrev();
      }
    };

    if (image !== null) {
      document.addEventListener('keydown', handleEscapeKey);
      document.addEventListener('keydown', handleRightArrowKey);
      document.addEventListener('keydown', handleLeftArrowKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('keydown', handleRightArrowKey);
      document.removeEventListener('keydown', handleLeftArrowKey);
    };
  }, [image, onClose, onNext, onPrev]);

  if (!image) {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 z-50 w-screen h-screen bg-black/80 cursor-pointer"
      onClick={onClose}
    >
      <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] flex flex-col justify-center items-center">
        <button
          className="absolute left-4 top-1/2 translate-y-[-50%] bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-200 cursor-pointer z-10"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          aria-label="Neste bilde"
        >
          <Arrow className="w-6 h-6 rotate-180" color="currentColor" />
        </button>
        <button
          className="absolute right-4 top-1/2 translate-y-[-50%] bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-200 cursor-pointer z-10"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          aria-label="Neste bilde"
        >
          <Arrow className="w-6 h-6" color="currentColor" />
        </button>
        <div className="w-[90vw] h-[90vh] relative">
          <ValImage
            className="object-contain"
            src={image}
            alt={image?.alt || 'På innsiden av Blank'}
            fill
            sizes="1200px"
          />
        </div>
        {showImageCaptions && (
          <p className="w-full text-xl p-16 text-center h-16">
            {image?.alt && image?.alt}
          </p>
        )}
      </div>
    </div>
  );
};

export { ImageModal };
